import { JSONPath } from 'jsonpath-plus';
import { MASKED_JSON_PATHS } from 'config/app-config';

export const maskJsonSensitiveData = (data: unknown): unknown => {
  const cloned = JSON.parse(JSON.stringify(data));

  MASKED_JSON_PATHS.forEach((path) => {
    JSONPath({
      path,
      json: cloned,
      callback: (value, _, { parent, parentProperty }) => {
        if (value !== null && value !== undefined && value !== '') {
          parent[parentProperty] = String(value).replace(/\S/g, '*');
        }
      }
    });
  });

  return cloned;
};
